import React from "react";
import { Doughnut, Line } from "react-chartjs-2";
import { numberConvert } from "./MainUtils";

export function PieChart(props) {
  const toplam = props.toplam;

  let labelCol = props.label.length / 2;
  let labelLimit = [];
  let defaultColors = ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#ffff99", "#b15928"];

  for (let i = 0; i < labelCol; i++) {
    labelLimit.push({ count: i === 0 ? 0 : i * 2 });
  }

  const getData = () => {
    return {
      labels: props.label,
      datasets: [
        {
          data: props.data,
          backgroundColor:
            props.color === undefined
              ? ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#ffff99", "#b15928"]
              : props.color,
          hoverBackgroundColor: ["#ffc107", "#ffc107", "#ffc107", "#ffc107", "#ffc107", "#ffc107", "#ffc107", "#ffc107", "#ffc107", "#ffc107", "#ffc107"],
          borderWidth: 0,
        },
      ],
    };
  };
  const colorFunc = (i) => {
    return props.color === undefined ? { backgroundColor: defaultColors[i], width: "5px" } : { backgroundColor: props.color[i], width: "5px" };
  };

  const legendFunc = (data) => {
    console.log(data, "data");
    let total = 0;
    props.data.map((d) => {
      return (total = total + parseInt(d));
    });
    return (
      <>
        <tr style={{ fontSize: "13px", fontWeight: "bold" }}>
          {props.label[data + 0] !== undefined ? (
            <>
              <th style={colorFunc(data + 0)}>&nbsp;</th>
              <td>{props.label[data + 0]}</td>
              <td>
                {props.noFixed ? props.data[data + 0] : numberConvert(parseFloat(props.data[data + 0]))}
                <br />
                {"(%" + parseFloat(((props.data[data + 0] / total) * 100).toFixed(1)) + ")"}
              </td>
            </>
          ) : null}
          {props.label[data + 1] !== undefined ? (
            <>
              <th style={colorFunc(data + 1)}>&nbsp;</th>
              <td>{props.label[data + 1]}</td>
              <td style={{ fontSize: "13px", fontWeight: "bold" }}>
                {props.noFixed ? props.data[data + 1] : numberConvert(parseFloat(props.data[data + 1]))}
                <br />
                {"(%" + parseFloat(((props.data[data + 1] / total) * 100).toFixed(1)) + ")"}
              </td>
            </>
          ) : null}
        </tr>
      </>
    );
  };

  const ShadowPlugin = {
    afterDraw: (chart) => {
      const { ctx } = chart;
      const { top } = chart.chartArea;

      let chartArea = chart.chartArea;
      let canvas = ctx.canvas;

      const centerX = (chartArea.left + chartArea.right) / 2;
      const centerY = (chartArea.top + chartArea.bottom) / 2;
      const r = Math.min((chartArea.right - chartArea.left) / 2, (chartArea.bottom - chartArea.top) / 2);

      var grd = ctx.createRadialGradient(centerX, centerY, 0, centerX, centerY, r);
      grd.addColorStop(0, "rgba(0, 0, 0,0.0)");
      grd.addColorStop(0.35, "rgba(0, 0, 0,0.0)");
      grd.addColorStop(0.65, "rgba(255, 255, 255,0.25)");
      grd.addColorStop(1, "rgba(0, 0, 0,0.0)");

      ctx.fillStyle = grd;
      ctx.fillRect(-10, top - 10, canvas.width, canvas.height);
    },
  };

  const formatBedelNoktaVirgulTr = (text) => {
    let formattedStr = "0";
    if (text !== undefined && text !== null && text !== "") {
      let num = parseFloat(text).toFixed(2).toString();
      let ar = num.split(".");
      let integerPart = ar[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");

      formattedStr = integerPart;
    }

    return formattedStr;
  };

  return (
    <div className="row" style={{ maxWidth: "100%", margin: "0px" }}>
      <div className="col-12" style={{ maxWidth: "100%" }}>
        <Doughnut
          data={getData}
          width={250}
          height={250}
          onElementsClick={() => {
            return;
          }}
          options={{
            onClick: function () {},
            maintainAspectRatio: false,
            title: {
              display: true,
              fontSize: 17,
            },

            plugins: {
              legend: {
                display: false, //props.legendVisible === undefined ? true : false,
                position: "bottom",
                align: "start",
                rtl: true,

                labels: {
                  fontSize: "12px",
                },
              },
              tooltip: {
                callbacks: {
                  label: function (tooltipItem) {
                    console.log(tooltipItem, "tooltipItem");
                    let total = 0;
                    tooltipItem.dataset.data.map((d) => {
                      return (total = total + parseInt(d));
                    });
                    var currentValue = tooltipItem.dataset.data[tooltipItem.dataIndex];
                    var percentage = parseFloat(((currentValue / total) * 100).toFixed(1));
                    return props.noFixed
                      ? tooltipItem.label + ": " + currentValue + (props.cins !== undefined ? props.cins : " ") + " (" + percentage + "%)"
                      : tooltipItem.label + ": " + parseFloat(currentValue) + (props.cins !== undefined ? props.cins : " ") + " (" + percentage + "%)";
                  },
                  title: function (tooltipItem) {
                    return tooltipItem.label;
                  },
                },
              },
            },
          }}
          plugins={[ShadowPlugin]}
        />
      </div>
      {props.legendVisible === undefined ? (
        <div className="col-12 shadow" style={{ fontSize: "11px", marginTop: "1px" }}>
          <table className="table table-sm table-bordered">
            <tbody>
              {labelLimit.map((d) => {
                return legendFunc(d.count);
              })}
              {toplam !== undefined ? (
                <tr>
                  <th style={{ textAlign: "right", backgroundColor: "#a6cee3" }} colSpan={6}>
                    <b>Toplam: {formatBedelNoktaVirgulTr(props.toplam)}</b>
                  </th>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}

export function BagimsizBolumSiraTable(params) {
  return (
    <table className="table table-bordered shadow-sm table-hover">
      <thead style={{ backgroundColor: "#3a90bf" }}>
        <tr>
          <th style={{ width: "100px" }}></th>
          <th>Çok Yüksek Öncelikli</th>
          <th>Yüksek Öncelikli</th>
          <th>Orta Öncelikli</th>
          <th>Az Düşük Öncelikli</th>
          <th>Düşük Öncelikli</th>
          <th>Çok Düşük Öncelikli</th>
          <th>Önceliksiz</th>
        </tr>
      </thead>
      <tbody>
        {params.data
          .map((item, index) => (
            <tr key={index}>
              <td>{item.label}</td>
              {item.jsonn_agg.map((value, i) => (
                <td key={i}>{value.sayi}</td>
              ))}
            </tr>
          ))
          .reverse()}
      </tbody>
    </table>
  );
}

export function ComboChart(params) {
  let zeminSayilari = params.data.map((d) => d.jsonn_agg.map((z) => z.sayi));

  console.log("DATA", params.data);
  console.log("ZEMİNADI", params.zeminOncelikIsim);
  console.log("zemin sayıları", zeminSayilari);

  const datasets = params.zeminOncelikIsim.map((item, index) => {
    let backgroundColorsToplam = [
      "rgba(255, 99, 132, 0.3)",
      "rgba(255, 159, 64, 0.3)",
      "rgba(255, 205, 86, 0.3)",
      "rgba(75, 192, 192, 0.3)",
      "rgba(54, 162, 235, 0.3)",
      "rgba(153, 102, 255, 0.3)",
      "rgba(150, 75, 0, 0.3)",
    ];

    let borderColorsToplam = [
      "rgb(255, 99, 132)",
      "rgb(255, 159, 64)",
      "rgb(255, 205, 86)",
      "rgb(75, 192, 192)",
      "rgb(54, 162, 235)",
      "rgb(153, 102, 255)",
      "rgb(201, 203, 207)",
    ];

    let borderColors = ["rgb(152, 136, 212)", "rgb(236,96,96)", "rgb(238,171,89)", "rgb(155,212,136)"];

    let backgroundColors = ["rgb(152, 136, 212)", "rgba(213,10,10)", "rgba(241,194,50)", "rgba(56,118,29)"];

    const backgroundColor = backgroundColors[index % backgroundColors.length];
    const borderColor = borderColors[index % borderColors.length];

    if (item == "Toplam") {
      return {
        type: "bar",
        label: [item],
        backgroundColor: backgroundColorsToplam,
        borderColor: borderColorsToplam,
        borderWidth: 1,
        data: zeminSayilari[index],
        zIndex: 2,
      };
    } else {
      return {
        type: "line",
        label: [item],
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderWidth: 2,
        fill: false,
        data: zeminSayilari[index],
      };
    }
  });

  const data = {
    labels: ["Çok Yüksek Öncelikli", "Yüksek Öncelikli", "Orta Öncelikli", "Az Düşük Öncelikli", "Düşük Öncelikli", "Çok Düşük Öncelikli", "Önceliksiz"],
    datasets: datasets,
  };

  const options = {
    plugins: {
      legend: {
        display: true,
        labels: {
          filter: (legendItem) => {
            return legendItem.datasetIndex != 0;
          },
        },
      },
    },
  };

  return (
    <h1>
      <Line data={data} options={options} />
    </h1>
  );
}
